import {
  Divider as MuiDivider,
  DividerProps as MuiDividerProps,
  Stack,
  SxProps,
  Theme,
  Typography
} from '@mui/material';
import React from 'react';

interface DividerProps extends MuiDividerProps {
  tone?: 'light' | 'dark';
  orientation?: 'horizontal' | 'vertical';
}

export function Divider({ tone = 'dark', orientation = 'horizontal', sx, ...props }: DividerProps) {
  const mergedStyles = { ...toneVariants[tone], ...sx };

  return <MuiDivider {...props} sx={mergedStyles} orientation={orientation} />;
}

export function DividerText({ text }: { text: string }) {
  return (
    <Stack direction="row" alignItems="baseline" spacing={3}>
      <Typography
        variant="labelXSmall"
        sx={{ color: theme => theme.brandPalette.foreground.neutralFaded }}
      >
        {text}
      </Typography>
      <Divider sx={{ flexGrow: 1 }} />
    </Stack>
  );
}

const toneVariants: Record<Required<DividerProps>['tone'], SxProps<Theme>> = {
  light: {
    borderColor: theme => theme.brandPalette.border.neutralFaded
  },
  dark: {
    borderColor: theme => theme.brandPalette.border.neutral
  }
};
